import { DropdownItem, DropdownItemContent, Icon } from '@yarmill/components';
import { MouseEvent, PropsWithChildren, ReactElement } from 'react';
import { trackUserMenuClick } from '../google-analytics/utils';
import * as React from 'react';
import { useListItem } from '@floating-ui/react';

export type UserSectionItemProps = PropsWithChildren<{
  isHeader?: boolean;
  dataTest?: string;
  icon?: ReactElement;
  linkHref?: string;
  linkTarget?: string;
  danger?: boolean;
  onClick?(): void;
  isActive?: boolean;
  getItemProps?: (
    userProps?: Omit<React.HTMLProps<HTMLElement>, 'selected' | 'active'>
  ) => Record<string, unknown>;
  closeDropdown?: () => void;
  ariaLabel?: string;
}>;

export function UserSectionItem(props: UserSectionItemProps): ReactElement {
  const {
    icon,
    linkHref,
    linkTarget,
    children,
    dataTest,
    onClick,
    isHeader,
    danger,
    getItemProps,
    isActive,
    closeDropdown,
    ariaLabel,
  } = props;
  const wrapperProps = linkHref
    ? { href: linkHref, target: linkTarget || undefined }
    : { type: 'button' };
  const item = useListItem();

  function handleClick(e: MouseEvent): void {
    closeDropdown?.();
    onClick?.();
    const { target } = e;
    if (target instanceof HTMLElement) {
      trackUserMenuClick(target.innerText);
    }
  }

  return (
    <DropdownItem
      ref={item.ref}
      {...wrapperProps}
      danger={danger}
      isHeader={isHeader}
      as={linkHref ? 'a' : 'button'}
      type={linkHref ? undefined : 'button'}
      data-cy={dataTest}
      role="menuitem"
      tabIndex={isActive ? 0 : -1}
      className={isActive ? 'active' : undefined}
      aria-label={ariaLabel}
      {...getItemProps?.({
        onClick: handleClick,
      })}
    >
      <DropdownItemContent>
        {icon && <Icon aria-hidden>{icon}</Icon>}
        {children}
      </DropdownItemContent>
    </DropdownItem>
  );
}
